import React from "react";
import { FaInstagram } from "react-icons/fa6";
import { FaTwitter } from "react-icons/fa";
// import { AiOutlineYoutube } from "react-icons/ai";
// import Logo from "../assets/icons/logo2.png";
import { FaFacebook } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { useNavigate } from "react-router-dom";
import Logo from "../assets/icons/CIMD LOGO 2.png";
// ..
AOS.init();

const Footer = () => {
  const navigate = useNavigate();
  return (
    <div>
      <div
        className="py-16 bg-primaryPurple text-white  lg:px-24 md:px-10 px-4 flex md:flex-row flex-col items-start md:ju
      stify-between justify-center md:text-left"
      >
        <div className="md:w-[25%] pt-4">
          <div className="lg:text-xl md:text-sm md:justify-start text-sm flex md:items-center items-start  gap-1">
            <img src={Logo} className="w-[12rem] lg:w-[12rem]" alt="" />
            {/* <p className="text-white font-bold text-xl md:text-sm">
              Clear-Icon-Medical
            </p> */}
          </div>
          <p className="py-2 md:text-sm">
            Providing accurate and reliable medical diagnostic services for your
            health needs.
          </p>
        </div>
        <div className="md:w-[25%] md:pl-8">
          <h1 className="font-semibold text-xl py-4">Quick Links</h1>
          <p
            className="py-4 md:text-sm  cursor-pointer"
            onClick={() => navigate("/")}
          >
            Home
          </p>
          <p
            className="pb-4 md:text-sm cursor-pointer"
            onClick={() => navigate("/services")}
          >
            Services
          </p>
          <p
            className="pb-4 md:text-sm cursor-pointer"
            onClick={() => navigate("/about")}
          >
            About Us
          </p>
          <p
            className="pb-4 md:text-sm cursor-pointer"
            onClick={() => navigate("/contact-us")}
          >
            Contact
          </p>
        </div>
        <div className="md:w-[25%]">
          <h1 className="font-semibold text-xl py-4">Services</h1>
          <p className="py-4 md:text-sm text-[12px]">Blood Analysis</p>
          <p className="pb-4 md:text-sm text-[12px]">Viral Screening</p>
          <p className="pb-4 md:text-sm text-[12px]">Organ Function Tests</p>
          <p className="pb-4 md:text-sm text-[12px]">Book Appointment</p>
        </div>
        <div className="md:w-[25%]">
          <h1 className="font-semibold text-xl py-4">Connect With Us</h1>
          <div className="flex items-center text-2xl text-white md:justify-normal gap-3">
            <FaFacebook />
            <a
              href="https://x.com/clearicon1?t=j10Uae1mLYf5_QCW8-18iQ&s=09"
              className="cursor-pointer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://ng.linkedin.com/company/clear-icon-medic-diagnostics"
              className="cursor-pointer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://www.instagram.com/clearicon_diagnostics?igsh=YzY3eGRjamI1YWJk"
              className="cursor-pointer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
